import axios from "axios"

const axiosInstance = axios.create({
  baseURL: "https://bonds.conv-ex.com/cms/wp-json/"
});

export default axiosInstance;